    <template v-if="true">
    <modal v-model:show="modal" body-classes="p-0" modal-classes="modal-dialog-centered modal-sm">
        <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-4 py-lg-5"
            class="border-0"
            style="margin-bottom: 0"
        >
            <template v-if="true">
                <div class="text-muted text-center mb-4">
                    <span>Criar uma nova conta</span>
                </div>
            </template>
            <template v-if="true">
                <form id="student-register-form" role="form" class="mt-4">
                    <base-input
                        v-model="model.name"
                        v-validate="'required'"
                        :name="$t('login.name')"
                        class="mb-3"
                        :placeholder="$t('login.name')"
                        prepend-icon="ni ni-circle-08"
                        :error="errors.first($t('login.name'))"
                    ></base-input>
                    <base-input
                        v-model="model.email"
                        v-validate="'required|email'"
                        :name="$t('login.email')"
                        class="mb-3"
                        :placeholder="$t('login.email')"
                        prepend-icon="ni ni-email-83"
                        :error="errors.first($t('login.email'))"
                    ></base-input>
                    <DocumentInput v-model="model" :required="requiredDocuments"/>
                    <base-input
                        v-model="model.password"
                        v-validate="'required'"
                        :name="$t('login.password.title')"
                        type="password"
                        :placeholder="$t('login.password.title')"
                        prepend-icon="ni ni-lock-circle-open"
                        :error="errors.first($t('login.password.title'))"
                    ></base-input>
                    <base-input
                        v-model="model.password_confirmation"
                        v-validate="{ is: model.password, required: true }"
                        :name="$t('login.password.confirm')"
                        type="password"
                        :placeholder="$t('login.password.confirm')"
                        prepend-icon="ni ni-lock-circle-open"
                        :error="errors.first($t('login.password.confirm'))"
                    ></base-input>
                    <div class="text-center">
                        <base-button
                            @click.stop="submit"
                            :loading="loading"
                            :style="$bgColor(color.button || color.primary)"
                            class="my-4"
                        >{{ $t('login.register') }}</base-button>
                    </div>
                </form>
            </template>
        </card>
    </modal>
</template>

<script>
import Card from "../../argon/components/Cards/Card";
import Modal from "../../argon/components/Modal";
import BaseButton from "../../argon/components/BaseButton";
import BaseInput from "../../argon/components/Inputs/BaseInput";

import DocumentInput from "../Common/DocumentInput";

export default {
    name: "Register",
    components: {
        Card,
        Modal,
        BaseButton,
        BaseInput,
        DocumentInput
    },
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: Boolean,
            required: true
        },
        color: {
            type: Object,
            required: true
        },
        requiredDocuments:{
            type: Boolean,
        }
    },
    data() {
        return {
            model: {
                name: "",
                email: "",
                document: "",
                document_type: "",
                password: "",
                password_confirmation: "",
                language: localStorage.getItem("lang")
            },
            form: [],
            loading: false
        };
    },
    computed: {
        modal: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },
        language() {
            return this.$store.getters.LANGUAGE;
        },
        redirectTo() {
            return this.$store.getters.REDIRECT_TO;
        }
    },
    methods: {
        submit() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    let terms =

                    window.axios
                        .post("/register", this.model)
                        .then(res => {
                            this.$notify({
                                type: "success",
                                message: res.data.message
                            });
                            localStorage.setItem(
                                "nochalks_token",
                                res.data.token
                            );

                            this.loginRegisteredUser();
                        })
                        .catch(err => {
                            console.log(err);
                            this.$notify({
                                type: "danger",
                                message: err.response.data.error
                            });
                            this.loading = false;
                        });
                }
            });
        },
        loginRegisteredUser() {
            window.axios
                .post("/authenticate", this.model)
                .then(res => {
                    this.$notify({
                        type: "success",
                        message: res.data.message
                    });
                    localStorage.setItem("nochalks_token", res.data.token);
                    localStorage.removeItem('redirect');
                    this.$redirect(this.redirectTo ? this.redirectTo : '/app/dashboard', 1500);
                })
                .catch(err => {
                    this.$notify({
                        type: "danger",
                        message: this.$t("login.messages.error")
                    });
                    this.loading = false;
                });
        }
    },

};
</script>

<style>
</style>
